import {FunctionComponent, MouseEventHandler, useCallback, useMemo} from "react";
import {useToastContainer} from "../../toast-container";
import {toast, ToastContentProps} from "react-toastify";
import classNames from "classnames";

export type ToastContentCloseButtonProps = ToastContentProps['toastProps'] & {
    includeCloseButton?: boolean,
};

const ToastContentCloseButton: FunctionComponent<ToastContentCloseButtonProps> = (props) => {
    const {activeToastIds} = useToastContainer();

    const showCloseAll = useMemo(() => {
        if (activeToastIds.length <= 1)
            return false;
        const toastId = props.toastId;
        return activeToastIds[activeToastIds.length - 1] === toastId;
    }, [activeToastIds, props.toastId]);

    /**
     * Closes all the active toasts.
     */
    const closeAllToasts = useCallback<MouseEventHandler<HTMLButtonElement>>((e) => {
        e.stopPropagation();
        e.preventDefault();
        for (const toastId of activeToastIds) {
            toast.dismiss({
                containerId: props.containerId!,
                id: toastId,
            })
        }
    }, [activeToastIds, props.containerId]);

    return (
        <>
            <div className={'toast-close-buttons-container'}>
                {
                    showCloseAll &&
                    <button onClick={closeAllToasts} className={'Toastify__close-all-button'} type="button" aria-label={'Close all toasts'}>
                        Clear all
                    </button>
                }
                {
                    props.includeCloseButton &&
                    <button
                        className={classNames(`Toastify__close-button`, {'Toastify__close-button--dark': props.theme === 'dark'})}
                        type="button"
                        onClick={props.closeToast}
                        aria-label={'close toast'}
                    >
                        <svg aria-hidden="true" viewBox="0 0 14 16">
                            <path
                                fillRule="evenodd"
                                d="M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
                            />
                        </svg>
                    </button>
                }
            </div>
        </>
    );
}


export default ToastContentCloseButton;
